interface AppGlobalVars {
  isMobile: boolean;
  lastCategoryRequestToken: number;
  lastSearchRequestToken: number;
  gtmPauseEvents: boolean;
  env: string;
  configuration: {
    [key: string]: any;
  };
}

const globalVars: AppGlobalVars = {
  isMobile: false,
  lastCategoryRequestToken: 0,
  lastSearchRequestToken: 0,
  env: 'dev',
  gtmPauseEvents: false,
  configuration: {
    react_app: {
      useReactProductPagesForCategories: [2752],
    },
  },
};

if (!process) {
  (window as any)._globalVars = globalVars;
}

export default globalVars;
